import cx from "classnames";

export class BemHelper {
  constructor(componentName){
    this.componentName = componentName;
  }

  get component(){
    return this.componentName;
  }

  for(childComponent, additionalClasses = []){
    return cx(
      [`${this.componentName}__${childComponent}`]
      .concat(typeof additionalClasses === "string" ? [additionalClasses] : additionalClasses),
    );    
  }
}